import React from 'react';
import DealDashboard from '../../../components/deals/DealDashboard';

const InvestorDeals: React.FC = () => {
  return <DealDashboard />;
};

export default InvestorDeals;